import React from 'react';
import { DominateSheetLayout } from 'features/command-center';
import usePageTitle from 'hooks/usePageTitle';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import strings from 'strings';
import { PageTitles } from 'UI/constants/defaults';
import { FeatureFlags } from 'UI/constants/featureFlags';

import { DOMINATE_TAB_IDS } from './constants';
import { FollowUpTasks } from './FollowUpTasks';
import { HotInventory } from './HotInventory';
import { Interviews } from './Interviews';
import { OutstandingBillings } from './OutstandingBillings';

const BASE_TABS = [
  {
    id: DOMINATE_TAB_IDS.activeInventory,
    label: strings.commandCenter.dominateSheet.mainTabs.activeInventory,
    view: <HotInventory />,
    visibleWhen: context => {
      const { featureFlagChecker } = context;
      return featureFlagChecker(FeatureFlags.CommandCenterDominateActiveTab);
    }
  },
  {
    id: DOMINATE_TAB_IDS.interviews,
    label: strings.commandCenter.dominateSheet.mainTabs.interviews,
    view: <Interviews />
  },
  {
    id: DOMINATE_TAB_IDS.outstandingBillings,
    label: strings.commandCenter.dominateSheet.mainTabs.outstandingBillings,
    view: <OutstandingBillings />
  },
  {
    id: DOMINATE_TAB_IDS.followUpTasks,
    label: strings.commandCenter.dominateSheet.mainTabs.followUpTasks,
    view: <FollowUpTasks />,
    visibleWhen: context => {
      const { featureFlagChecker } = context;
      return featureFlagChecker(FeatureFlags.FollowUpTasks);
    }
  }
];

export const DominateSheet = () => {
  usePageTitle({ title: PageTitles.CommandCenterDominateSheet });

  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  const tabs = BASE_TABS.filter(
    item =>
      item.visibleWhen === undefined ||
      item.visibleWhen({ featureFlagChecker: checkIfFeatureFlagEnabled })
  );

  return <DominateSheetLayout tabs={tabs} />;
};
